import * as actionTypes from "../../actions/actionTypes";

const initState = {
  transactions: [],
  fetchTransactionsLoading: false,
  fetchTransactionsError: null,
  filtersLoading: false,
  filtersApplied: false,
  filtersReset: false,
  transaction: {},
  fetchTransactionLoading: false,
  fetchTransactionError: null,
  actionLoading: false,
  actionMessageSuccess: "",
  actionMessageFailed: "",
  rejectRemarks: [],
  rejectRemarksError: null,
  stores: [],
  storesLoading: false,
  storesError: null,
  branches: [],
  branchesLoading: false,
  branchesError: null,
  addBranchLoading: false,
  addBranchSuccessMessage: "",
  addBranchErrorMessage: "",
};

const transactionReducer = (state = initState, action) => {
  switch (action.type) {
    case actionTypes.FETCH_TRANSACTIONS_START:
      return {
        ...state,
        fetchTransactionsLoading: true,
      };
    case actionTypes.FETCH_TRANSACTIONS_SUCCESS:
      return {
        ...state,
        fetchTransactionsLoading: false,
        total: action.total,
        transactions: action.transactions,
        filtersReset: false,
      };
    case actionTypes.FETCH_TRANSACTIONS_FAILED:
      return {
        ...state,
        total: 0,
        fetchTransactionsLoading: false,
        fetchTransactionsError: action.error,
      };
    // FILTER
    case actionTypes.FILTER_TRANSACTIONS_START:
      return {
        ...state,
        filtersLoading: true,
      };
    case actionTypes.FILTER_TRANSACTIONS_SUCCESS:
      return {
        ...state,
        filtersLoading: false,
        filtersApplied: true,
      };
    case actionTypes.FILTER_TRANSACTIONS_RESET:
      return {
        ...state,
        filtersLoading: false,
        filtersApplied: false,
        filtersReset: true,
      };
    // TRANSACTION
    case actionTypes.FETCH_TRANSACTION_START:
      return {
        ...state,
        fetchTransactionLoading: true,
        actionMessageFailed: null,
        actionMessageSuccess: null,
      };
    case actionTypes.FETCH_TRANSACTION_SUCCESS:
      return {
        ...state,
        fetchTransactionLoading: false,
        transaction: { ...action.transaction },
      };
    case actionTypes.FETCH_TRANSACTION_FAILED:
      return {
        ...state,
        fetchTransactionLoading: false,
        fetchTransactionError: action.err,
      };
    case actionTypes.APPROVE_RECEIPT_START:
      return {
        ...state,
        actionLoading: true,
        actionMessageFailed: null,
        actionMessageSuccess: null,
      };
    case actionTypes.APPROVE_RECEIPT_SUCCESS:
      return {
        ...state,
        actionLoading: false,
        actionMessageSuccess: action.successMessage,
      };
    case actionTypes.APPROVE_RECEIPT_FAILED:
      return {
        ...state,
        actionLoading: false,
        actionMessageFailed: action.errorMessage,
      };

    // DISCARD
    case actionTypes.DISCARD_TRANSACTION_START:
      return {
        ...state,
        actionLoading: true,
        actionMessageSuccess: null,
        actionMessageFailed: null,
      };
    case actionTypes.DISCARD_TRANSACTION_SUCCESS:
      return {
        ...state,
        actionLoading: false,
        actionMessageSuccess: action.successMessage,
      };
    case actionTypes.DISCARD_TRANSACTION_FAILED:
      return {
        ...state,
        actionLoading: false,
        actionMessageFailed: action.errorMessage,
      };

    case actionTypes.REJECT_RECEIPT_START:
      return {
        ...state,
        actionLoading: true,
        actionMessageSuccess: null,
        actionMessageFailed: null,
      };
    case actionTypes.REJECT_RECEIPT_SUCCESS:
      return {
        ...state,
        actionLoading: false,
        actionMessageSuccess: action.successMessage,
      };
    case actionTypes.REJECT_RECEIPT_FAILED:
      return {
        ...state,
        actionLoading: false,
        actionMessageFailed: action.errorMessage,
      };
    case actionTypes.REANALYZE_RECEIPT_START:
      return {
        ...state,
        actionLoading: true,
      };
    case actionTypes.REANALYZE_RECEIPT_SUCCESS:
      return {
        ...state,
        actionLoading: false,
        actionMessage: action.successMessage,
      };
    case actionTypes.REANALYZE_RECEIPT_FAILED:
      return {
        ...state,
        actionLoading: false,
        actionMessageFailed: action.errorMessage,
      };
    case actionTypes.FETCH_REJECT_REMARKS_START:
      return {
        ...state,
      };
    case actionTypes.FETCH_REJECT_REMARKS_SUCCESS:
      return {
        ...state,
        rejectRemarks: action.remarks,
      };
    case actionTypes.FETCH_REJECT_REMARKS_FAILED:
      return {
        ...state,
        rejectRemarksError: action.err,
      };

    // STORES
    case actionTypes.FETCH_STORES_START:
      return {
        ...state,
        storesLoading: true,
      };
    case actionTypes.FETCH_STORES_SUCCESS:
      return {
        ...state,
        stores: action.stores,
        storesLoading: false,
      };
    case actionTypes.FETCH_STORES_FAILED:
      return {
        ...state,
        storesError: action.err,
        storesLoading: false,
      };
    case actionTypes.FETCH_BRANCHES_START:
      return {
        ...state,
        branchesLoading: true,
      };
    case actionTypes.FETCH_BRANCHES_SUCCESS:
      return {
        ...state,
        branches: action.branches,
        branchesLoading: false,
      };
    case actionTypes.FETCH_BRANCHES_FAILED:
      return {
        ...state,
        branchesLoading: false,
        branchesError: action.err,
      };
    case actionTypes.ADD_BRANCH_START:
      return {
        ...state,
        addBranchLoading: true,
      };
    case actionTypes.ADD_BRANCH_SUCCESS:
      return {
        ...state,
        addBranchLoading: false,
        addBranchSuccessMessage: action.successMessage,
      };
    case actionTypes.ADD_BRANCH_FAILED:
      return {
        ...state,
        addBranchLoading: false,
        addBranchErrorMessage: action.errorMessage,
      };
    case actionTypes.EDIT_TRANSACTION_START:
      return {
        ...state,
        actionLoading: true,
        actionMessageFailed: null,
        actionMessageSuccess: null,
      };
    case actionTypes.EDIT_TRANSACTION_SUCCESS:
      return {
        ...state,
        actionLoading: false,
        actionMessageSuccess: action.successMessage,
      };
    case actionTypes.EDIT_TRANSACTION_FAILED:
      return {
        ...state,
        actionLoading: false,
        actionMessageFailed: action.errorMessage,
      };
    case actionTypes.RESEND_COUPON_START:
      return {
        ...state,
        actionLoading: true,
        actionMessageFailed: null,
        actionMessageSuccess: null,
      };
    case actionTypes.RESEND_COUPON_SUCCESS:
      return {
        ...state,
        actionLoading: false,
        actionMessageSuccess: action.successMessage,
      };
    case actionTypes.RESEND_COUPON_FAILED:
      return {
        ...state,
        actionLoading: false,
        actionMessageFailed: action.errorMessage,
      };
    case actionTypes.FRAUD_DETECT_START:
      return {
        ...state,
        actionLoading: true,
        actionMessageFailed: null,
        actionMessageSuccess: null,
      };
    case actionTypes.FRAUD_DETECT_SUCCESS:
      return {
        ...state,
        actionLoading: false,
        actionMessageSuccess: action.response,
      };
    case actionTypes.FRAUD_DETECT_FAILED:
      return {
        ...state,
        actionLoading: false,
        actionMessageFailed: action.err,
      };
    default:
      return state;
  }
};

export default transactionReducer;
